import globalStore from '$$globalStore';
import projectsModel from '$$projectModel';
import getValueForUserColumn from './getValueForUserColumn';

export default function (task, columnId) {
  const ganttID = task.gantt_id || projectsModel.getActiveGanttId();

  if (!ganttID) {
    return '';
  }
  const column = globalStore.getters['columns/getCustomColumnById'](columnId);

  return getValueForUserColumn(task, column);
}
